import { TFunction } from 'i18next'

import { InvoiceComplianceMode } from '@features/invoices/enums/invoiceComplianceMode'

import { MissingCustomerDetailsFormSchema } from '../types/missingCustomerDetailsFormSchema'
import { getCustomerFormValidationSchema } from './getCustomerFormValidationSchema'
import { getFrenchCustomerFormValidationSchema } from './getFrenchCustomerFormValidationSchema'

interface GetCustomerFormValidationSchemaByComplianceModeOptions {
  complianceMode: InvoiceComplianceMode
  t: TFunction
}

const validationSchemaByComplianceMode: Record<
  InvoiceComplianceMode,
  (t: TFunction) => MissingCustomerDetailsFormSchema
> = {
  [InvoiceComplianceMode.Default]: getCustomerFormValidationSchema,
  [InvoiceComplianceMode.French]: getFrenchCustomerFormValidationSchema,
}

export const getCustomerFormValidationSchemaByComplianceMode = ({
  complianceMode,
  t,
}: GetCustomerFormValidationSchemaByComplianceModeOptions): MissingCustomerDetailsFormSchema =>
  validationSchemaByComplianceMode[complianceMode](t)
